module.exports = __webpack_public_path__ + "media/icons/temperature-da485adc430587be96c2210b801dc07c.svg";